import React, { useCallback, useEffect, useState } from 'react';

import logo from '../img/logo_black.svg';

export const PageTemplate = React.memo(({ children }) => {
  const [clicks, setClicks] = useState(0);
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    let timer;
    if (clicks > 0) {
      timer = setTimeout(() => {
        setClicks(0);
      }, 3 * 1000);
    }
    return () => clearTimeout(timer);
  }, [clicks]);

  useEffect(() => {
    if (clicks === 5) {
      alert('Hey, curious explorer! 👀 Love your persistence! 🚀');
      setLogos((prev) => [
        ...prev,
        ...Array(10)
          .fill(null)
          .map((_, i) => ({
            id: prev.length + i,
            left: i * (100 / 10) + 'vw',
          })),
      ]);
      setClicks(0);
    }
  }, [clicks]);

  const handleClick = useCallback(() => {
    setClicks((prev) => prev + 1);
  }, []);

  useEffect(() => {
    const element = document.getElementById('easter-egg');
    if (element) {
      element.addEventListener('click', handleClick);
    }
    return () => {
      if (element) {
        element.removeEventListener('click', handleClick);
      }
    };
  }, [handleClick]);

  return (
    <div className="relative mx-auto mt-[230px] flex max-w-[800px] flex-col px-[20px]">
      <div className="pointer-events-none absolute flex size-full items-center justify-center gap-[20px] overflow-hidden opacity-20">
        {logos.map((item) => (
          <img
            key={item.id}
            src={logo}
            className="pointer-events-none absolute w-[200px] animate-float"
            style={{
              left: item.left,
              top: `calc(40vh - ${Math.random() > 0.5 ? 20 : 0}px)`,
              transform: `rotate(${Math.random() * 40 - 10}deg)`,
            }}
          />
        ))}
      </div>
      {children}
    </div>
  );
});
